import React, { useState, useEffect } from 'react';
import { Box, Grid, GridItem, Img, Text } from '@chakra-ui/react';
import ScrollbarInteraction from 'components/customScroll/CustomScrollInteraction'
// import Scrollbar from 'components/customScroll/CustomScroll';

interface InteractionProps {
  data: any;
  options: any;
  optionClick: any;
  InteractionFunction: () => void;
  option: any;
  navTrack?: any;
  preloadedAssets: any;
  selectedPlayer: any;
  LastModiPrevData: any;
  RepeatSelectOption: any;
  RepeatPrevOption: any;
  contentByLanguage: any;
  currentScreenId?: number;
  gameInfo: any;
  animateInteraction?: boolean;
  profile?: any;
}

const Interaction: React.FC<InteractionProps> = ({
  data,
  option,
  options,
  optionClick,
  InteractionFunction,
  navTrack,
  preloadedAssets,
  selectedPlayer,
  LastModiPrevData,
  RepeatSelectOption,
  RepeatPrevOption,
  contentByLanguage,
  currentScreenId,
  gameInfo,
  animateInteraction,
  profile,
}) => {
  const [prevSelectOption, setprevselectoptions] = useState<any>();

  const [hasClicked, setHasClicked] = useState(false);

  useEffect(() => {
    if (RepeatSelectOption === true) {
      if (RepeatPrevOption.length > 0) {
        const prevoptionseleted = RepeatPrevOption;

        setprevselectoptions(prevoptionseleted);
      }
    } else {
      setprevselectoptions([]);
    }
  }, [RepeatSelectOption]);

  useEffect(() => {
    if (hasClicked === true) {
      setHasClicked(false);
    }
  }, [option]);
  const blockPrimarySequenceParts = data?.blockPrimarySequence.split('.');
  const primaryKey = blockPrimarySequenceParts
    ? parseInt(blockPrimarySequenceParts[0])
    : null;

  const sequenceMatches =
    primaryKey !== null &&
    gameInfo.blocks.hasOwnProperty(primaryKey) &&
    data?.blockPrimarySequence ===
      gameInfo.blocks[primaryKey]?.['1']?.blockPrimarySequence;
  const playerHeight = document.getElementById('player');
  return (
    <Box className="chapter_potrait" zIndex={9}>
      <Grid
        templateColumns="repeat(1, 1fr)"
        gap={4}
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        w={'90%'}
      >
        <GridItem colSpan={1} position={'relative'}>
          <Box position={'relative'} className="story_interaction_image">
            <Img
              src={preloadedAssets.parch}
              w={'auto'}
              h={'100%'}
              loading="lazy"
            />
            <Box
              position={'absolute'}
              top={{ base: '5%', md: '6%' }}
              className="story_interaction_content"
            >
              <Box
                textAlign={'center'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                fontWeight={500}
                // fontSize={{ md: '3vw', lg: '2.5vw' }}
                fontFamily={'AtlantisText'}
                lineHeight={1}
                w={'100%'}
                h={'10%'}
                className={'interaction_heading_potrait'}
              >
                <Box w={'80%'} color={'#312821'}>
                  Interaction{' '}
                </Box>
              </Box>
              <Box
                textAlign={'center'}
                h={'50vh'}
                display={'flex'}
                // justifyContent={'center'}
                alignItems={'center'}
                fontWeight={500}
                fontFamily={'AtlantisText'}
                lineHeight={1.1}
                w={'100%'}
                marginTop={'7%'}
                position={'relative'}
                flexDirection={'column'}
                css={{
                  // Hide scrollbar for webkit-based browsers (Safari, Chrome)
                  '&::-webkit-scrollbar': {
                    display: 'none',
                  },
                  // Hide scrollbar for Mozilla-based browsers (Firefox)
                  'scrollbar-width': 'none', // For Firefox
                  '-ms-overflow-style': 'none', // For IE and Edge
                }}
              >
                {/* <Box w={'60%'}> */}
                <ScrollbarInteraction width={'70%'} className="custom-scroll-blink">
                  <Box
                    className={'story_intraction_question'}
                    justifyContent={'flex-start'}
                  >
                    <Img src={preloadedAssets.qs} h={'1em'} w={'1em'} />
                    <Text overflowWrap={'anywhere'}>
                      {contentByLanguage !== null
                        ? contentByLanguage
                        : data?.blockText}
                    </Text>
                  </Box>
                  <Box className="story_options_area">
                    <Box w={'100%'}>
                      {options &&
                        options.map((item: any, ind: number) => (
                          <Box
                            w={'100%'}
                            mb={'10px'}
                            lineHeight={1}
                            key={ind}
                            color={
                              prevSelectOption?.some(
                                (prev: any) => prev === item.qpOptions,
                              )
                                ? 'white'
                                : option === ind
                                ? 'purple'
                                : ''
                            }
                            style={
                              prevSelectOption?.some(
                                (prev: any) => prev === item.qpOptions,
                              )
                                ? {
                                    opacity: 0.7,
                                    color: 'grey',
                                  }
                                : {}
                            }
                          >
                            <Box
                              w={'100%'}
                              mb={'10px'}
                              lineHeight={1}
                              key={ind}
                              color={option === ind ? 'purple' : ''}
                              textAlign={'center'}
                              onClick={() => {
                                if (
                                  !prevSelectOption ||
                                  !prevSelectOption.some(
                                    (prev: any) => prev === item.qpOptions,
                                  )
                                ) {
                                  optionClick(item, ind);
                                }
                              }}
                              fontFamily={'AtlantisText'}
                            >
                              <Img
                                src={
                                  prevSelectOption?.some(
                                    (prev: any) => prev === item.qpOptions,
                                  )
                                    ? preloadedAssets.on
                                    : option === ind
                                    ? preloadedAssets.on
                                    : preloadedAssets.off
                                }
                                opacity={
                                  prevSelectOption?.some(
                                    (prev: any) => prev === item.qpOptions,
                                  )
                                    ? 0.5
                                    : 1
                                }
                                h={'4vh'}
                                w={'100%'}
                              />
                              <Box
                                className={'story_interaction_option'}
                                overflowWrap={'anywhere'}
                              >
                                {`${String.fromCharCode(65 + ind)}). ${
                                  item?.qpOptionText
                                }`}
                              </Box>
                            </Box>
                          </Box>
                        ))}
                    </Box>
                  </Box>
                </ScrollbarInteraction>
                {/* </Box> */}
              </Box>
              <Box w={'98%'} display={'flex'} justifyContent={'space-between'}>
                {sequenceMatches ? (
                  <Img />
                ) : (
                  <Img
                    src={preloadedAssets.left}
                    className={'interaction_button'}
                    onClick={() => {
                      LastModiPrevData(data);
                    }}
                  />
                )}

                {option !== null && (
                  <Box className={'blinking-wave'} borderRadius={'50%'}>
                    <Img
                      src={preloadedAssets.right}
                      className={'interaction_button'}
                      onClick={() => {
                        if (!hasClicked) {
                          console.log('right-button');
                          setHasClicked(true);
                          InteractionFunction();
                        }
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default Interaction;
